
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-tracked-storage-polyfill/-embroider-implicit-modules.js";
